import Navbar from '../components/navbar';
import SpecialCollection from '../components/homepage/specialCollection';
import Footer from '../components/footer';
import '../App.scss';

const Home = () => {

	document.title = "Special Collection — AAPI Film and TV";
    return (
		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>

			
		  
			<body> <div className='gray-primary text-white'> <br/><br/><br/>
			<h1 className='text-white'> Special Collection: AAPI Film and TV</h1> <br/><br/><br/></div>

				<div id="film">
					<SpecialCollection
						titles={"The Farewell, Minari, Everything Everywhere All at Once, Turning Red, Past Lives, Moana 2"}
						sectionName={"AAPI Film"}/>
				</div>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<div id="tv">
					<SpecialCollection
						titles={"Kim's Convenience-s2, Patriot Act with Hasan Minhaj-s6, Pen15-s1, Never Have I Ever-s1, Beef, XO, Kitty-s1, Interior Chinatown, Chief of War"}
						sectionName={"AAPI TV"}/>
				</div>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<Footer/>
			</body>
		</div>
	  );
}

export default Home;
